export { default as TrafficLocation } from './TrafficLocation';
